<template>
  <div>
    <div :key="question.order" v-for="question in questions" >
      <div class="question" v-bind:class="{active:question.id === questionActive}" @click="select(question)">
        <div style="width: 100%; padding-right: 6px;"><span>{{question.question}}</span></div>
        <div><img :src="question.id === questionActive ? icons.MINUS : icons.PLUS"/></div>
      </div>
      <div v-show="question.id === questionActive" class="response" v-html="question.response" @click="selectResponse($event)"></div>
    </div>
  </div>
</template>
<script>
import { ICONS } from '@/constants/help-center'

export default {
  name: 'Questions',
  props: {
    questions: {
      type: Array
    },
    active: {
      type: String
    }
  },
  data () {
    return {
      questionActive: '',
      icons: ICONS
    }
  },
  mounted () {
    this.questionActive = this.active !== '' ? this.active : this.questions[0].id
  },
  methods: {
    /**
     * Abre una pregunta y avisa cuál fue.
     * @param {Object} question - Pregunta tocada
     */
    select (question) {
      this.questionActive = question.id
      this.$emit('select', question.question)
    },

    /**
     * Si el clic fue sobre un link de la respuesta avisa la pregunta activa y el texto del link.
     * @param {MouseEvent} event - Clic dentro de la respuesta
     */
    selectResponse (event) {
      if (event.target.getAttribute('ref') !== 'links') return
      const active = this.questions.find(item => item.id === this.questionActive)
      this.$emit('link', { question: active.question, link: event.target.innerText || '' })
    }
  }
}
</script>
<style>
.centro-de-ayuda .question {
  font-family: 'Omnes Semibold'!important;
  font-style: normal!important;
  font-weight: 500!important;
  font-size: 16px!important;
  line-height: 15px!important;
  color: #454A6C!important;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5)!important;
  transform: matrix(1, 0, 0, 1, 0, 0)!important;
  cursor: pointer!important;
  padding-top: 17px!important;
  padding-bottom: 2px!important;
  display: flex;
}
.centro-de-ayuda .question span{
  font-family: 'Omnes Semibold'!important;
  color: #454A6C!important;
}
.centro-de-ayuda .question.active span{
  color: #00ADEE!important;
}
.centro-de-ayuda .question img {
  float: right!important;
  padding-right: 13px!important;
}
.centro-de-ayuda .response {
  font-family: 'Omnes Regular'!important;
  font-style: normal!important;
  font-weight: 400!important;
  font-size: 14px!important;
  line-height: 16px!important;
  padding-top: 20px!important;
  margin-bottom: -10px!important;
  color: rgba(0, 0, 0, 0.8)!important;
}
@media only screen and (max-width: 768px) {
  .centro-de-ayuda .question {
    font-size: 14px!important;
  }
  .centro-de-ayuda .response {
    font-size: 14px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/help-center/Questions.vue